import { render } from "./OptionsModal.vue?vue&type=template&id=704b93b8&scoped=true&ts=true"
import script from "./OptionsModal.vue?vue&type=script&lang=ts"
export * from "./OptionsModal.vue?vue&type=script&lang=ts"

import "./OptionsModal.vue?vue&type=style&index=0&id=704b93b8&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704b93b8"]])

export default __exports__